import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/base/services/base.service';
import { ProcessoAbas } from '../models/processo-abas.model';

@Injectable()
export class ProcessoAbasService extends BaseService<ProcessoAbas> {
  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/pre-projeto/processo-abas';
  }

  public salvarOrdem(obj: any[]): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/salvar-ordem', obj, {
      headers: this.headers,
    });
  }

  public getTiposList(): Observable<[]> {
    return this.http.get<[]>(this.baseUrl + '/tipos-list', {
      headers: this.headers,
    });
  }
}
